<template>
	<div class="d-flex flex-column flex h100">
		<navbar></navbar>
		<div class="app">
			<config-sidenav></config-sidenav>
			<div id="content" class="app-content box-shadow-3">
				<!-- Optional navbar at top of page -->
				<div class="navbar navbar-expand-lg bg-white">
					<!-- Page title -->
					<div class="navbar-text nav-title flex" id="pageTitle">Essential Skills</div>

					<!-- Create new -->
					<div v-if="user.role.page_config_standards" class="py-0">
						<a href="#/essential_skills/new" class="btn btn-sm theme-accent btn-block">
							<i class="far fa-fw fa-plus"></i>
							<span class="hidden-folded d-inline">New Essential Skill</span>
						</a>
					</div>

					<!-- Search field -->
					<div>
						<form class="input-group m-2 my-lg-0">
							<span class="input-group-btn">
								<button type="button" class="btn no-border no-bg no-shadow">
									<i class="fa fa-search"></i>
								</button>
							</span>
							<input
								type="text"
								v-model="filter"
								class="form-control"
								placeholder="Search Essential Skills ..."
							/>
						</form>
					</div>
				</div>

				<div class="content-main">
					<div class="">
						<!-- Page essential skill goes here -->
						<b-table
							ref="table"
							responsive="lg"
							striped
							hover
							:show-empty="true"
							:items="table_provider"
							:fields="table_fields"
							:current-page="currentPage"
							:per-page="perPage"
							:filter="filter"
							:sort-by.sync="sortBy"
							:sort-desc.sync="sortDesc"
						>
							<!-- Edit -->
							<template slot="actions" slot-scope="data">
								<nobr>
									<div class="mx-auto w60">
										<a
											:href="`#/essential_skills/${data.item.id}`"
											class="btn btn-sm btn-icon btn-rounded hover-darken theme-accent m-0"
											v-tippy
											title="Edit"
										>
											<i class="far fa-edit"></i>
										</a>
										<button
											v-if="!data.item.inProgress && user.role.page_config_standards"
											@click="deleting = data.item"
											class="btn btn-sm btn-icon btn-rounded hover-darken red text-white m-0"
											v-tippy
											title="Delete"
										>
											<i class="far fa-trash"></i>
										</button>
										<button
											v-if="data.item.inProgress && user.role.page_config_standards"
											class="btn btn-sm btn-icon btn-rounded m-0"
											v-tippy
											title="Removing..."
										>
											<loading type="icon" />
										</button>
									</div>
								</nobr>
							</template>

							<template slot="empty">
								<loading type="table" v-if="loading" />
								<div v-if="!loading">
									There are no records to show
								</div>
							</template>
						</b-table>
					</div>
				</div>

				<div class="p-1 b-t mt-auto white d-flex flex-row align-items-center">
					<a class="flex mx-3"
						>Page {{ totalRows > 0 ? currentPage : 0 }} of {{ Math.ceil(totalRows / perPage) }} ({{
							totalRows
						}})</a
					>
					<div>
						<b-pagination
							size="md"
							class="m-1"
							:total-rows="totalRows"
							v-model="currentPage"
							:per-page="perPage"
						></b-pagination>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="deleteConfirm" :visible="deleting != false" v-if="deleting">
			<template slot="modal-title">
				Delete Essential Skill
			</template>
			<div class="row p-4">
				Are you sure you want to delete&nbsp;
				<strong class="text-theme">{{ deleting.name }}</strong
				>?
			</div>
			<template slot="modal-footer">
				<button class="btn primary btn-flat" @click="deleting = false">Cancel</button>
				<button class="btn danger btn-flat" @click="removeEssentialSkill(deleting)">Delete</button>
			</template>
		</b-modal>

		<mzfooter></mzfooter>
	</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.w60 {
	width: 60px;
}
</style>

<script>
import EssentialSkillService from "@/services/EssentialSkillService";
import notie from "@/services/NotieService";
import store from "@/services/Store";

export default {
	name: "EssentialSkillSetup",

	props: ["user"],

	data() {
		return {
			table_fields: [
				{ key: "name", tdClass: "_600", sortable: true },
				{
					key: "actions",
					thStyle: { "text-align": "center" },
					tdClass: "p-custom p-0 v-mid"
				}
			],
			currentPage: 1,
			perPage: 15,
			totalRows: 0,
			filter: "",
			sortBy: null,
			sortDesc: false,
			loading: true,

			deleting: false
		};
	},

	components: {},

	created() {
		this.sortBy = store.get(this, "essentialSkills.sortBy");
		this.sortDesc = store.getDefault(this, "essentialSkills.sortDesc", false);
	},

	watch: {
		sortBy() {
			store.set(this, "essentialSkills.sortBy", this.sortBy);
		},
		sortDesc() {
			store.set(this, "essentialSkills.sortDesc", this.sortDesc);
		}
	},

	methods: {
		table_provider(ctx) {
			return EssentialSkillService.listEssentialSkills(ctx)
				.then(resp => {
					this.totalRows = resp.data.totalRows;
					console.log(resp.data)
					return resp.data.essential_skills;
				})
				.catch(err => {
					console.log(err);
					notie.error("Failed to load EssentialSkills", err);
					return [];
				})
				.finally(() => {
					this.loading = false;
				});
		},

		removeEssentialSkill(essentialSkill) {
			essentialSkill.inProgress = true;
			EssentialSkillService.removeEssentialSkill(essentialSkill.id)
				.then(resp => {
					notie.info("Essential Skill deleted");
					this.refreshTable();
				})
				.catch(err => {
					notie.error("Failed to delete Essential Skill", err);
				})
				.finally(() => {
					essentialSkill.inProgress = false;
					this.$forceUpdate();
				});
			this.deleting = false;
		},

		refreshTable() {
			this.$refs.table.refresh();
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/vues/SetupConfig/EssentialSkillSetup.vue